module.exports = __webpack_public_path__ + "img/mine-head.cd8b2477.png";